import React, {useCallback, useEffect} from 'react';
import classNames from 'classnames';
import {ViewMode} from '@taopix/taopix-core';
import {Button, ListViewIcon, GridViewIcon, Theme, ThemeName} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {ButtonProps} from '@taopix/taopix-design-system/dist/types/Components/Button/Button';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';
import useViewMode from '../../Hooks/useViewMode';
import {useTaopix} from '../Context/TaopixContext';
import {useTranslation} from 'react-i18next';

const PreviewViewModeSelector = () => {
  const ui = useUiState();
  const app = useTaopix();
  const [viewMode] = useViewMode();
  const {t} = useTranslation(['main']);

  // switch to list view when going into small screen
  useEffect(() => {
    if (ui.state.isSmallScreen && ViewMode.Grid === ui.state.previewViewMode) {
      ui.dispatch(UserInterfaceActions.setPreviewViewMode(ViewMode.List));
    }
  }, [ui.state.isSmallScreen, ui.state.previewViewMode]);

  const onSetPreviewViewMode = useCallback(
    (newMode: ViewMode) => {
      if (ViewMode.Grid === newMode && ui.state.zoomLevel > 100) {
        ui.dispatch(UserInterfaceActions.setZoomLevel(100));
        app.core.get('abilities').setZoom(100, false, false);
      }
      // setSelectedPreviewViewMode(newMode);
      ui.dispatch(UserInterfaceActions.setPreviewViewMode(newMode));
    },
    [ui.state.zoomLevel]
  );

  const setViewMode = (newViewMode: ViewMode) => {
    // Trigger the callback function
    onSetPreviewViewMode(newViewMode);
  };

  const viewModeBarClasses = classNames('flex', 'shadow-md', 'overflow-hidden');

  const buttonStyleProps: ButtonProps = {
    hideLabel: true,
    buttonStyle: 'standard',
    size: ui.state.isSmallScreen ? 'medium' : 'small',
    labelLines: 1,
    corners: 'square',
  };
  return (
    <>
      {!ui.state.isSmallScreen && ViewMode.Preview === viewMode && (
        <Theme name={ThemeName.Popouts} className={viewModeBarClasses}>
          <Button
            label={t('main:str_ButtonListView')}
            startIcon={<ListViewIcon />}
            aria-pressed={ui.state.previewViewMode === ViewMode.List}
            onClick={() => setViewMode(ViewMode.List)}
            {...buttonStyleProps}
          />
          <Button
            label={t('main:str_ButtonGridView')}
            startIcon={<GridViewIcon />}
            aria-pressed={ui.state.previewViewMode === ViewMode.Grid}
            onClick={() => setViewMode(ViewMode.Grid)}
            {...buttonStyleProps}
          />
        </Theme>
      )}
    </>
  );
};

export default PreviewViewModeSelector;
